import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {execBI} from '../services/bi-events-manager';
import {FormattedMessage, injectIntl} from 'react-intl';
import {urls} from '../config';
import {getUserDetailsPromise} from '../services/wrapped-app-market-sdk';
import {connect} from 'react-redux';

const sendAppSuggestion = (app, user, mode, formSubmitCount) => {

  const body = {
    appName: app.name,
    description: app.desc,
    metaSiteId: mode.query.metaSiteId,
    from: user,
    fromEmail: user + '@wishlist.wix.com'
  };

  const options = {
    method: 'POST',
    credentials: 'same-origin',
    body: JSON.stringify(body),
    headers: {'Content-Type': 'application/json;charset=UTF-8'}
  };

  return fetch(mode.origin + urls.suggestAnApp, options)
    .then(resp => {
      if (resp.status >= 200 && resp.status < 300) {
        execBI('WISH_LIST_SEND_SUCCESS', {
          title: app.name,
          description: app.description,
          success: !!formSubmitCount
        });
      } else {
        throw new Error('API error');
      }
    });
};


const getUserName = (market) => {
  return new Promise((resolve, reject) => {
    if (market === 'editor') {
      getUserDetailsPromise().then(resolve).catch(reject);

    } else if (market === 'standalone') {
      if (window.W.Site.Common.UserDetailsServer.isSessionValid()) {
        window.W.Site.Common.UserDetailsServer.get((resp) => resolve(resp.userName));
      } else {
        resolve('anonymous');
      }
    } else {
      reject('business manager get user email');
    }
  });
};


class SuggestAnApp extends React.Component {

  constructor(props) {
    super(props);
    this.formSubmitCount = 0;
    this.hide = this.hide.bind(this);
    this.handleSubmitSuggestion = this.handleSubmitSuggestion.bind(this);
    this.handleShowAnotherForm = this.handleShowAnotherForm.bind(this);
    this.handleValidateForm = this.handleValidateForm.bind(this);
  }

  handleSubmitSuggestion(ev) {
    ev.preventDefault();
    if (this.appName.value.length && this.appDescription.value.length) {
      this.setState({loading: true});
      execBI('WISH_LIST_SEND_CLICK', {success: !!this.formSubmitCount});

      getUserName(this.props.mode.market)
        .then((user) => sendAppSuggestion({name: this.appName.value, desc: this.appDescription.value}, user, this.props.mode, this.formSubmitCount))
        .then(() => this.setState({showThankYou: true, loading: false, error: null}))
        .catch(() => this.setState({error: 'Server error. Try again later.', loading: false}));
    }
  }

  handleShowAnotherForm(ev) {
    ev.preventDefault();
    this.formSubmitCount++;
    execBI('WISH_LIST_ANOTHER_CLICK');
    this.setState({showThankYou: false, formInvalid: true});
  }

  handleValidateForm() {
    this.setState({formInvalid: !(this.appName.value.length && this.appDescription.value.length)});
  }

  renderForm() {
    const {formatMessage} = this.props.intl;
    const state = this.state || {formInvalid: true};

    return (
      <div className="suggestion-form">
        <div className="head">
          <div className="title">
            <FormattedMessage id="wishlist.title"/>
          </div>
          <div className="icon"></div>
        </div>
        <div className="body">
          <div className="description">
            <FormattedMessage id="wishlist.description"/>
          </div>
          <div className="form-container">
            <form name="suggestionForm">
              <div className="form-group appName">
                <div className="input-label">
                  <FormattedMessage id="wishlist.form.name"/>
                </div>
                <input onKeyUp={this.handleValidateForm} type="text" className="form-control app-name" placeholder={formatMessage({id: 'wishlist.placeholder.name'})} ref={i => this.appName = i}/>
              </div>
              <div className="form-group appDescription">
                <div className="input-label">
                  <FormattedMessage id="wishlist.form.description"/>
                </div>
                <textarea onKeyUp={this.handleValidateForm} className="form-control app-description" ref={i => this.appDescription = i} placeholder={formatMessage({id: 'wishlist.placeholder.description'})} required></textarea>
              </div>

              <div style={{color: 'red'}}>{state.error}</div>

              <button type="submit" onClick={this.handleSubmitSuggestion}
                      className={classNames('button-send button-blue-short', {'loading': state.loading, 'button-send-disabled': state.formInvalid})}
                      >
                {this.loading ?
                  <FormattedMessage id="application.action.openLoading"/> :
                  <FormattedMessage id="wishlist.button.send"/>
                }
              </button>
              <button type="button" className="button-cancel button-light-blue" onClick={ev => this.hide(ev, 'cancel')}>
                <FormattedMessage id="wishlist.button.cancel"/>
              </button>
            </form>
          </div>
        </div>
      </div>
    );
  }

  renderThankYou() {
    return (
      <div className="thankyou">
        <div className="head">
          <div className="title">
            <FormattedMessage id="wishlist.thankyou.title"/>
          </div>
          <div className="icon"></div>
        </div>
        <div className="body">
          <div className="description">
            <FormattedMessage id="wishlist.thankyou.description"/>
          </div>
          <div className="another-suggestion">
            <button type="button"
                    className="button-add-another button-light-blue"
                    onClick={this.handleShowAnotherForm}
                    >
              <FormattedMessage id="wishlist.thankyou.addAnotherSuggestion"/>
            </button>
            <button type="button" className="button-done button-blue-short" onClick={(ev) => this.hide(ev, 'done')}>
              <FormattedMessage id="wishlist.button.done"/>
            </button>
          </div>
        </div>
      </div>
    );
  }

  hide(ev, type) {
    const state = this.state || {};
    ev.preventDefault();
    this.props.hide();

    if (state.showThankYou) {
      execBI('WISH_LIST_CLOSE_ON_SUCCESS', {closing_method: type});
    } else {
      execBI('WISH_LIST_CLOSE', {closing_method: type});
    }
  }

  render() {
    const state = this.state || {};

    return (
      <div className="suggest-an-app">
        <div className="suggest-an-app-overlay" onClick={(ev) => this.hide(ev, 'click_out')}></div>
        <div className={classNames('dialog', {'thankyou-container': state.showThankYou})}>
          <button type="button" className="close" onClick={(ev) => this.hide(ev, 'x')}>
            <span>&times;</span>
          </button>

          {!state.showThankYou ? this.renderForm() : ''}
          {state.showThankYou ? this.renderThankYou() : ''}
        </div>
      </div>
    );
  }
}

SuggestAnApp.propTypes = {
  intl: PropTypes.object,
  hide: PropTypes.func,
  mode: PropTypes.object
};

export default connect((state) => ({mode: state.mode}))(injectIntl(SuggestAnApp));



// WEBPACK FOOTER //
// ./components/Suggest-an-app.js